/**
 * The payment deadline on an unpaid enrolment (23.09.2026): 48 hours from the
 * moment the payment was started — 24 in a cohort with three seats or fewer
 * left (24.09.2026) — after which the seat is freed and the person moves to
 * Leaduri. Pure, so tested.
 */
export function deadlineNote(deadline, now = new Date(), hours = null) {
  if (!deadline) return { tone: "held", text: "Fără termen de plată: înscrierea nu expiră automat." };
  const at = new Date(deadline);
  if (Number.isNaN(at.getTime())) return null;
  const when = at.toLocaleString("ro-RO", { dateStyle: "short", timeStyle: "short" });
  // Why this one is earlier than the usual 48 hours, said where it is read.
  const why = hours && hours < 48 ? ` Termen scurt, de ${hours} de ore: grupa mai are cel mult 3 locuri.` : "";
  const leftHours = Math.round((at - now) / 3600000);
  if (leftHours <= 0) {
    return { tone: "due", text: `Termenul de plată a trecut (${when}). Locul se eliberează la următoarea verificare.` };
  }
  const left = leftHours < 24 ? `${leftHours} ${leftHours === 1 ? "oră" : "ore"}` : `${Math.round(leftHours / 24)} zile`;
  return { tone: "open",
    text: `Termen de plată: ${when} (mai are ${left}). Apoi locul se eliberează și persoana trece la Leaduri.${why}` };
}
